import {HTTP} from '../../../services/api-service.js';
import commonObj from '../../../services/common.js';
var common = new commonObj();
var baseUrl = common.baseURL;
var tableName = 'EntityAC';

const vendorStore = {
    namespaced: true,
    state:{
        totalItem:0,
        q : {
            tableNeedQuery: tableName,
            isOuterJoin: false,       
            searchCriteria: "EntType='v'",
            orderBy: "EntNum,asc",
            take: 1000000,
            skip: 0
        },
        currentSelectedPage: 0,
    },
    actions:{
        getAllVendors({commit,state},param) {
            return new Promise((resolve, reject) => {
                HTTP.post(baseUrl + '/qgl/listvalue', state.q).then(response => {
                    resolve(response);
                })
                .catch(e => {
                    reject(e);
                });
            });
        }
    }
};
export default vendorStore;